import * as yup from 'yup';
import { API as departments } from '../../departments/api';
import { API as languages } from '../../suppliers/api';
import { PriorityOptions, StarsOptions, TargetOptions } from './Data.conf';
import dayjs from 'dayjs';
import { API as marina } from '../../marina/api';
import { API as categories } from '../../categories/api';
import { API as subCategories } from '../../subCategories/api';

export const CreateConf = {
    schema: yup.object({
        label: yup.string().nullable().required('Supplier is required'),
        company_name: yup.string().nullable().required('Company Name is required'),
        mexal_code: yup.string().nullable(),
        address: yup.string().nullable(),
        phone_number: yup.string().nullable(),
        email: yup.string().nullable(),
        website: yup.string().nullable(),
        year: yup.date().nullable().transform((value) => {
            if (value && dayjs(value).isValid()) return value;
            return null;
        }),
        vat_number: yup.string().nullable(),
        sdi_code: yup.string().nullable(),
        id_category: yup.array().nullable(),
        id_sub_category: yup.array().nullable(),
        id_departments: yup.array().nullable(),
        priority: yup.object().nullable(),
        supplier_contacts: yup.array().nullable(),
        opening_date: yup.date().nullable().transform((value) => {
            if (value && dayjs(value).isValid()) return value;
            return null;
        }),
        closing_date: yup.date().nullable().transform((value) => {
            if (value && dayjs(value).isValid()) return value;
            return null;
        }),
        id_languages: yup.array().nullable(),
        target: yup.object().nullable(),
        details: yup.string().nullable(),
        stars: yup.object().nullable(),
        working_hours: yup.string().nullable(),
        services_on_board: yup.boolean().nullable(),
        fares: yup.string().nullable(),
        commissions: yup.string().nullable(),
        cancellation_fees: yup.string().nullable(),
        notes: yup.string().nullable(),
        rules: yup.string().nullable(),
        other_contacts: yup.string().nullable(),
        bank_details: yup.string().nullable(),
    }),
    defaultValues: {
        label: null,
        company_name: null,
        mexal_code: null,
        address: null,
        phone_number: null,
        email: null,
        website: null,
        year: null,
        vat_number: null,
        sdi_code: null,
        id_category: null,
        id_sub_category: null,
        id_departments: null,
        priority: null,
        supplier_contacts: [],
        opening_date: null,
        closing_date: null,
        id_languages: null,
        target: null,
        details: '',
        stars: null,
        working_hours: '',
        services_on_board: null,
        fares: '',
        commissions: '',
        cancellation_fees: '',
        notes: '',
        rules: '',
        other_contacts: '',
        bank_details: '',
    },
    fields: [
        {
            id: 'supplier_info_divider',
            type: 'divider',
            label: 'Supplier Info',
            xs: 12,
        },
        {
            id: 'mexal_code',
            name: 'mexal_code',
            type: 'mexal_suppliers',
            label: 'Mexal Code',
            xs: 12,
            md: 6,
        },
        {
            id: 'label',
            name: 'label',
            type: 'text',
            label: 'Supplier',
            required: true,
            xs: 12,
            md: 6,
        },
        {
            id: 'address',
            name: 'address',
            type: 'text',
            label: 'Address',
            xs: 12,
            md: 6,
        },
        {
            id: 'phone_number',
            name: 'phone_number',
            type: 'text',
            label: 'Main Phone Number',
            xs: 12,
            md: 6,
        },
        {
            id: 'email',
            name: 'email',
            type: 'text',
            label: 'E-Mail',
            xs: 12,
            md: 6,
        },
        {
            id: 'website',
            name: 'website',
            type: 'text',
            label: 'Website',
            xs: 12,
            md: 6,
        },
        {
            id: 'year',
            name: 'year',
            type: 'date',
            label: 'Year',
            xs: 12,
            md: 6,
        },
        {
            id: 'company_name',
            name: 'company_name',
            type: 'text',
            label: 'Company Name',
            required: true,
            xs: 12,
            md: 6,
        },
        {
            id: 'vat_number',
            name: 'vat_number',
            type: 'text',
            label: 'Vat Number',
            xs: 12,
            md: 6,
        },
        {
            id: 'sdi_code',
            name: 'sdi_code',
            type: 'text',
            label: 'Codice Univoco (SDI)',
            xs: 12,
            md: 6,
        },
        {
            id: 'divider',
            type: 'divider',
            label: '',
            xs: 12,
        },
        {
            id: 'id_category',
            name: 'id_category',
            type: 'async_autocomplete_multiple',
            label: 'Category',
            api: categories.select,
            required: false,
            xs: 12,
            md: 6,
        },
        {
            id: 'id_sub_category',
            name: 'id_sub_category',
            type: 'async_autocomplete_multiple',
            label: 'Sub Category',
            api: subCategories.select,
            required: false,
            xs: 12,
            md: 6,
        },
        {
            id: 'id_departments',
            name: 'id_departments',
            type: 'async_autocomplete_multiple',
            label: 'Department',
            api: departments.suppliersActiveDepartments,
            required: false,
            xs: 12,
            md: 6,
        },
        {
            id: 'priority',
            name: 'priority',
            type: 'autocomplete',
            label: 'Priority',
            options: PriorityOptions,
            xs: 12,
            md: 6,
        },
        {
            id: 'id_locations',
            name: 'id_locations',
            type: 'async_autocomplete_multiple',
            label: 'Locations',
            api: marina.select,
            xs: 12,
            md: 6,
        },

        // Supplier Contacts section
        {
            id: 'supplier_divider',
            type: 'divider',
            label: 'Supplier Contacts',
            xs: 12,
        },
        {
            id: 'supplier_contacts',
            name: 'supplier_contacts',
            type: 'add_more_form_fields',
            label: '',
            xs: 12,
            options: [
                {
                    id: 'main_contact',
                    name: 'main_contact',
                    type: 'text',
                    label: 'Name',
                    xs: 12,
                    sm: 4,
                },
                {
                    id: 'main_contact_phone_number',
                    name: 'main_contact_phone_number',
                    type: 'text',
                    label: 'Phone',
                    xs: 12,
                    sm: 4,
                },
                {
                    id: 'main_contact_email',
                    name: 'main_contact_email',
                    type: 'text',
                    label: 'E-mail',
                    xs: 12,
                    sm: 4,
                },
            ],
        },

        // Operational Details section
        {
            id: 'operational_details_divider',
            type: 'divider',
            label: 'Operational Details',
            xs: 12,
        },
        {
            id: 'opening_date',
            name: 'opening_date',
            type: 'date',
            label: 'Opening Date',
            xs: 12,
            md: 6,
        },
        {
            id: 'closing_date',
            name: 'closing_date',
            type: 'date',
            label: 'Closing Date',
            xs: 12,
            md: 6,
        },
        {
            id: 'id_languages',
            name: 'id_languages',
            type: 'async_autocomplete_multiple',
            label: 'Other Languages',
            api: languages.otherLanguages,
            required: false,
            xs: 12,
            md: 6,
        },
        {
            id: 'target',
            name: 'target',
            type: 'autocomplete',
            options: TargetOptions,
            label: 'Target',
            xs: 12,
            md: 6,
        },
        {
            id: 'details',
            name: 'details',
            type: 'text',
            label: 'Details',
            xs: 12,
            md: 6,
        },
        {
            id: 'stars',
            name: 'stars',
            type: 'autocomplete',
            options: StarsOptions,
            label: 'Stars',
            xs: 12,
            md: 6,
        },
        {
            id: 'services_on_board',
            name: 'services_on_board',
            type: 'switch',
            label: 'Services On Board',
            xs: 12,
            md: 6,
        },
        {
            id: 'working_hours',
            name: 'working_hours',
            type: 'text',
            label: 'Working Hours',
            xs: 12,
            md: 6,
        },
        {
            id: 'fares',
            name: 'fares',
            type: 'text',
            label: 'Fares',
            xs: 12,
            md: 6,
        },
        {
            id: 'commissions',
            name: 'commissions',
            type: 'text',
            label: 'Commissions',
            xs: 12,
            md: 6,
        },
        {
            id: 'cancellation_fees',
            name: 'cancellation_fees',
            type: 'text',
            label: 'Cancellation Fees',
            xs: 12,
            md: 6,
        },
        {
            id: 'notes',
            name: 'notes',
            type: 'text',
            label: 'Notes',
            xs: 12,
            md: 6,
        },
        {
            id: 'rules',
            name: 'rules',
            type: 'text',
            label: 'Rules',
            required: false,
            xs: 12,
        },
        {
            id: 'other_contacts',
            name: 'other_contacts',
            type: 'text',
            label: 'Other Contacts',
            xs: 12,
            md: 6,
        },
        // Invoicing Details section
        {
            id: 'invoicing_details',
            type: 'divider',
            label: 'Invoicing Details',
            xs: 12,
        },
        {
            id: 'bank_details',
            name: 'bank_details',
            type: 'text',
            label: 'Bank Details',
            xs: 12,
            md: 6,
        },
    ],
};
